function getmajorMinor() {
  var majorMinor = window.JTComponents.version.split(".")[0];
  majorMinor += "." + window.JTComponents.version.split(".")[1];
  return majorMinor;
}

function getmajorMinorDir() {
  var majorMinor = "v";
  majorMinor += window.JTComponents.version.split(".")[0];
  majorMinor += "_" + window.JTComponents.version.split(".")[1];
  return majorMinor;
}

export function injectVersion() {
  const majorMinor = getmajorMinor();
  document.querySelectorAll(".js-version").forEach(function (el) {
    el.textContent = majorMinor;
  });
  document.querySelectorAll(".js-version-full").forEach(function (el) {
    el.textContent = window.JTComponents.version.trim();
  });
}

export function setTheme(client) {
  const oldLink = document.querySelector('#dynamic-style');
  oldLink?.remove();
  const majorMinor = getmajorMinor();
  if (client === "") {
    document.head.insertAdjacentHTML(
      "beforeend",
      `<link type="text/css" rel="stylesheet" id="dynamic-style" href="${getmajorMinorDir()}/jt.ui.theme.bundle.css"/>`
    );
  } else {
    document.head.insertAdjacentHTML(
      "beforeend",
      `<link type="text/css" rel="stylesheet" id="dynamic-style" href="${getmajorMinorDir()}/channel/${client}/jt.ui.theme.bundle.css"/>`
    );
  }
}
